import {
    SETUP_APP, SET_BRANCH, RESET_BRANCH
} from '../actions/types';
import changeFavicon from '../utils/favicon-changer';
import cssInject from '../utils/css-injector';
import { getStorage, setStorage } from '../cache';

const cache = getStorage();

const INITIAL_STATE = {
    chain: cache.chain || { id: cache.chainId },
    branch: cache.branch,
    brand: { ...cache.brand },
    orderTypes: cache.orderTypes || [],
    supportTableNumberField: cache.supportTableNumberField || false
};

cache.brand && cache.brand.assets.logo.assets.length > 0 && changeFavicon(cache.brand.assets.logo.assets[0].url);
cache.brand && cssInject(cache.brand.theme.cssRawData);
if (cache.chain) { document.title = cache.chain.name; }

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SETUP_APP:
            setStorage({ brand: action.payload.brand, chain: action.payload.chain, branch: action.payload.branch, orderTypes: action.payload.orderTypes, supportTableNumberField: action.payload.supportTableNumberField });
            action.payload.brand && action.payload.brand.assets.logo.assets.length > 0 && changeFavicon(action.payload.brand.assets.logo.assets[0].url);
            action.payload.brand && cssInject(action.payload.brand.theme.cssRawData);
            if (action.payload.chain) { document.title = action.payload.chain.name; }
            return { ...state, brand: action.payload.brand, chain: action.payload.chain, branch: action.payload.branch, orderTypes: action.payload.orderTypes, supportTableNumberField: action.payload.supportTableNumberField };
        case SET_BRANCH: {
            setStorage({ branch: action.payload });
            return { ...state, branch: action.payload };
        }
        case RESET_BRANCH: {
            setStorage({ branch: undefined });
            return { ...state, branch: undefined };
        }
        default:
            return state;
    }
};
